export const facebookUrl = "https://www.facebook.com/GoMoIre/?modal=admin_todo_tour";

export const twitterUrl = "https://twitter.com/gomoireland";

export const instagramUrl = "https://www.instagram.com/gomoireland/";

export const youtubeUrl = "https://www.youtube.com/channel/UCgYW09mzqOJUCupRGF5SIiQ";
